/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * Session Payment method Response
 */

// required attributes
const SessionPaymentMethodResponseR = t.interface({
  sessionId: t.string,

  bin: t.string,

  lastFourDigits: t.string,

  expiringDate: t.string,

  brand: t.string
});

// optional attributes
const SessionPaymentMethodResponseO = t.partial({});

export const SessionPaymentMethodResponse = t.intersection(
  [SessionPaymentMethodResponseR, SessionPaymentMethodResponseO],
  "SessionPaymentMethodResponse"
);

export type SessionPaymentMethodResponse = t.TypeOf<
  typeof SessionPaymentMethodResponse
>;
